export const home = "/home";
export const login = "/login";
export const urlUpdate = "/url-update";
export const Testimonial = "#Testimonial";
export const progressReport = "/progress-report";
export const userProfile = "/user-profile";
export const notification = "/notification";
export const forgotPassword = "/forgot-password";
export const createAccount = "/create-account";
export const scheduleType = "/schedule";